import React from 'react'
import cn from 'classnames'
import WithGlobalNav from '@groovehq/internal-design-system/lib/components/GlobalNav/WithGlobalNav/WithGlobalNav'

import SearchModifier from 'components/SearchModifier/Desktop/Modal'
import MailtoHandler from 'components/MailtoHandler'
import ManageModal from 'components/App/DesktopView/Labels/ManageModal'
import AppNotices from 'components/AppNotices'
import GlobalNav from 'components/App/DesktopView/Layout/GlobalNav'

import LayoutSwitcher from './LayoutSwitcher'
import HotkeysModal from './HotkeysModal'
import KeyboardHandler from './KeyboardHandler'
import Leftnav from './Leftnav'
import SUIModalWrapper from './SUIModalWrapper'

import styles from './styles.less'
import NoMailboxAccess from './NoMailboxAccess'

const Layout = ({
  areTicketsSelected,
  hasSearchErrored,
  isBulkSelectionMode,
  isMerging,
  isNewConversation,
  isNewEmail,
  isQueryStringValid,
  isUpdateAvailable,
  listTitle,
  queryObject,
  queryString,
  queryStringIsComplete,
  ticketIds,
  ticketId,
  showDemoMailboxBar,
  hasMailboxAccess,
  isLeftSidebarCollapsed,
  ...rest
}) => {
  return (
    <div className={cn(styles.app)}>
      <KeyboardHandler />
      <WithGlobalNav
        globalNav={<GlobalNav active="Inbox" />}
        topContent={<AppNotices />}
        leftSidebar={hasMailboxAccess && <Leftnav />}
        isLeftSidebarCollapsed={isLeftSidebarCollapsed}
      >
        {hasMailboxAccess && (
          <div className={cn('TicketingApp', styles.content)}>
            <SearchModifier />
            <LayoutSwitcher
              areTicketsSelected={areTicketsSelected}
              hasSearchErrored={hasSearchErrored}
              isBulkSelectionMode={isBulkSelectionMode}
              isMerging={isMerging}
              isNewConversation={isNewConversation}
              isNewEmail={isNewEmail}
              isQueryStringValid={isQueryStringValid}
              isUpdateAvailable={isUpdateAvailable}
              listTitle={listTitle}
              queryStringIsComplete={queryStringIsComplete}
              ticketIds={ticketIds}
              {...rest}
            />
          </div>
        )}
        {!hasMailboxAccess && <NoMailboxAccess />}
      </WithGlobalNav>
      <HotkeysModal />
      <ManageModal key="tag-manage-modal" />
      <SUIModalWrapper />
      <MailtoHandler />
    </div>
  )
}

export default Layout
